import { render, staticRenderFns } from "./event_parts_for_products.vue?vue&type=template&id=2d054ee4&"
import script from "./event_parts_for_products.vue?vue&type=script&lang=js&"
export * from "./event_parts_for_products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports